import React from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import Required from "./Required";
import { handleSelectChange } from "../../../utils/Utils";
import MyLabel from "./MyLabel";

const MySelect = ({
  title,
  multi,
  name,
  placeholder,
  register,
  watch,
  errors,
  setValue,
  trigger,
  options,
  required,
  disabled,
}) => {
  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required}/>
      <div className="form-control-wrap">
        <Select
          isMulti={multi}
          placeholder={placeholder}
          //  className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          id={name}
          options={options}
          {...register(name, {
            required: {
              value: required,
              message: `Please select ${title}`,
            },
          })}
          onChange={(e) => handleSelectChange(e, name, setValue, trigger)}
          value={watch(name)}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: errors?.[name] ? "red" : "grey",
            }),
          }}
          isDisabled={disabled}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MySelect;
